import GlobalHandler from '../services/global_handler';

const globalHandler = new GlobalHandler();
window.globalHandler = globalHandler;
export default globalHandler;
